import { useContext, useEffect } from 'react';
import { OnboardingContext } from 'providers/OnboardingContext';

// ? Maybe this should be a function in the context itself instead of a hook
const useOnboarding = (
  currentOnboarding: string,
  actionProps?: any,
  clearOnFinish?: any,
  startDelay: number = 0
) => {
  const { changeCurrentOnboarding, setRemoveActionCallbacks, setActionProps, enabled } =
    useContext(OnboardingContext);

  useEffect(() => {
    if (localStorage.getItem('onboarding_welcome') === 'true') {
      !!actionProps && setActionProps(actionProps);
      !!clearOnFinish && setRemoveActionCallbacks(clearOnFinish);
      setTimeout(() => {
        currentOnboarding && changeCurrentOnboarding(currentOnboarding);
      }, startDelay);
    }
  }, [
    changeCurrentOnboarding,
    setRemoveActionCallbacks,
    setActionProps,
    currentOnboarding,
    actionProps,
    clearOnFinish,
    startDelay,
  ]);

  return enabled;
};

export default useOnboarding;
